import {ExternalIcons} from './ExternalIcons'

export const Header = () => {
	return (
		<header className={'header'}>
			<ExternalIcons />
		</header>
	)
}
